import { SimpleObservable } from "./SimpleObservable";

export interface SidebarType {
  id: number;
  component: JSX.Element;
  config?: SidebarConfig;
}

export type SidebarConfig = {
  noClose?: boolean;
  position?: "left" | "right";
  width?: string;
};

export class SidebarService extends SimpleObservable {
  private nextId = 0;
  private sidebar!: SidebarType;
  private activeSidebars = new Set<number>();

  public getSidebar(): SidebarType {
    return this.sidebar;
  }

  public hasSidebar() {
    return this.activeSidebars.size > 0;
  }

  public nameIs(name: string) {
    return this.hasSidebar() && this.sidebar?.component?.type?.name === name;
  }

  public showSidebar(component: JSX.Element, config?: SidebarConfig): Promise<number> {
    return new Promise((resolve) => {
      const id = this.nextId++;
      this.sidebar = {
        id,
        component,
        config,
      };

      this.activeSidebars.add(id);
      this.inform({ type: "show", data: null });

      resolve(id);
    });
  }

  public closeSidebar(id?: number): void {
    const sidebarId = id ?? this.sidebar?.id;
    if (sidebarId !== undefined) {
      this.activeSidebars.delete(sidebarId);
    }
    this.inform({ type: "hide", data: sidebarId });
  }

  public closeAll(): void {
    const idsToClose = Array.from(this.activeSidebars);
    this.activeSidebars.clear();
    idsToClose.forEach(id => {
      this.inform({ type: "hide", data: id });
    });
  }
}

export const sidebarService = new SidebarService();
